import { defineSlotRecipe } from '@chakra-ui/react';

export const fieldsetSlotRecipe = defineSlotRecipe({
  className: 'fieldset',
  slots: ['root', 'content', 'errorText', 'helperText', 'legend'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    legend: {
      display: 'flex',
      alignItems: 'center',
      width: 'full',
      height: '47px',
      color: 'neutral.white',
      fontWeight: 'regular',
      fontFamily: 'space',
      fontSize: 'xl',
      lineHeight: '100%',
      textAlign: 'start',
      letterSpacing: '4px',
    },
    helperText: {
      width: '100%',
      color: 'neutral.200',
      textStyle: 'roboto',
      textAlign: 'left',
      fontWeight: 'regular',
      lineHeight: '125%',
      whiteSpace: 'pre-line',
    },
    errorText: {
      marginTop: 3,
      padding: 2,
      minHeight: '52px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: 'neutral.white',
      backgroundColor: 'red.100',
      gap: '2',
      fontWeight: 'medium',
      fontStyle: 'roboto',
    },
  },

  variants: {
    size: {
      sm: {
        root: { spaceY: '2' },
        content: { gap: '1.5' },
        legend: { textStyle: 'sm' },
      },
      md: {
        root: { spaceY: 3 },
        content: { gap: 3 },
        legend: { textStyle: 'sm' },
      },
      lg: {
        root: { spaceY: '6' },
        content: { gap: '4' },
        legend: { textStyle: 'md' },
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
});
